import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AnnouncementSlide from './AnnouncementSlide';
import { useAppSelector } from '../../../redux/features/redux-hooks';
import MainHeader from './MainHeader';

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const basicUserInfo = useAppSelector((state) => state.authState.basicUserInfo);

  const appBarHeight = isMobile ? '60px' : isTablet ? '75px' : '60px';

  return (
    <>
      <AnnouncementSlide />
      <MainHeader
        appBarHeight={appBarHeight}
        isMobile={isMobile}
        isTablet={isTablet}
        basicUserInfo={basicUserInfo}
      />
    </>
  );
};

export default Header;
